import React from 'react'
import Select from 'react-select'
import i18n from 'live/services/i18n'
import Description from './helper/description'
import { ConfigProps } from './Interface'

const defaultPositions = ['percent', 'value', 'compare', 'text', 'hide']
const defaultAlignVertical = ['middle', 'bottom', 'top', 'left', 'right']

const Config = (props: ConfigProps) => {
    console.log('props config', props.config)
    const OPTIONS = {
        optionsPositions: defaultPositions.map(value => ({
            value,
            label: value ? value[0].toUpperCase() + value.slice(1) : value
        })),
        optionsAlignVertical: defaultAlignVertical.map(value => ({ value, label: value }))
    }
    const formatOptionValue = value => {
        return { value, label: value }
    }

    const { type_1, type_2, text } = props.config

    const textInfo =
        'Set the type of the nthxx line of the graph; in case of comparison, define the max using "__max", and in case of text, define the text using "__text".'
    console.log('render config')

    return (
        <div>
            <div style={{ padding: '4px 2px' }}>
                <label>
                    {i18n('Text')}
                    <Description text={i18n(textInfo.replace('nthxx', 'text'))} />
                </label>
                <input value={text} onChange={({ target }) => props.onChange('text', target.value)} />
            </div>

            <div style={{ padding: '4px 2px' }}>
                <label>
                    {i18n('First row')}
                    <Description text={i18n(textInfo.replace('nthxx', 'first event'))} />
                </label>
                <Select
                    multi={false}
                    clearable={false}
                    searchable={false}
                    options={OPTIONS.optionsPositions}
                    value={formatOptionValue(type_1)}
                    onChange={e => props.onChange('type_1', e.value)}
                />
            </div>

            <div style={{ padding: '4px 2px' }}>
                <label>
                    {i18n('Second row')}
                    <Description text={i18n(textInfo.replace('nthxx', 'second event'))} />
                </label>
                <Select
                    multi={false}
                    clearable={false}
                    searchable={false}
                    options={OPTIONS.optionsPositions}
                    value={formatOptionValue(type_2)}
                    onChange={e => props.onChange('type_2', e.value)}
                />
            </div>
        </div>
    )
}
export default React.memo(Config)
